/**
 * True when THIS event came from a pointer that hovers — mouse, trackpad or pen — as
 * opposed to a finger.
 *
 * The toolbar menus open submenus on pointer-enter, which only makes sense for a pointer
 * that can hover without committing. Gating that on the DEVICE gets hybrids wrong:
 * `innerWidth >= 848` calls an iPad a desktop, and `matchMedia('(hover: hover)')` reports
 * the PRIMARY pointer, so a touchscreen laptop answers "hovers" even mid-tap. On either,
 * a finger fires enter (opening the submenu) then click (closing it), so one tap does
 * nothing. The question is per-gesture, so ask the gesture.
 *
 * Pen counts as hovering: an Apple Pencil genuinely does.
 *
 * NOT a test for horizontal room — `computeSubmenuMobileStyle` still uses width, because
 * whether a flyout fits beside the panel really is a question about width.
 */
export const isHoveringPointer = (event) => event?.pointerType !== 'touch';
